module.exports = __webpack_public_path__ + "img/ic_filter-01.10195840.svg";